import styledTheme from "common/theme";

//have to use linear-gradient so it is compatible with html2canvas that we are using for reports, otherwise stripes do not render
export const blueAngledStripesGradient = `linear-gradient(
  -45deg,
  ${styledTheme.colors.jbtBlue} 0px,
  ${styledTheme.colors.jbtBlue} 3px,
  white 3px,
  white 6px,
  ${styledTheme.colors.jbtBlue} 6px,
  ${styledTheme.colors.jbtBlue} 9px,
  white 9px,
  white 12px,
  ${styledTheme.colors.jbtBlue} 12px,
  ${styledTheme.colors.jbtBlue} 15px,
  white 15px,
  white 18px,
  ${styledTheme.colors.jbtBlue} 18px,
  ${styledTheme.colors.jbtBlue} 21px,
  white 21px,
  white 24px,
  ${styledTheme.colors.jbtBlue} 24px,
  ${styledTheme.colors.jbtBlue} 27px,
  white 27px,
  white 30px,
  ${styledTheme.colors.jbtBlue} 30px,
  ${styledTheme.colors.jbtBlue} 33px,
  white 33px,
  white 36px,
  ${styledTheme.colors.jbtBlue} 36px,
  ${styledTheme.colors.jbtBlue} 39px,
  white 39px,
  white 42px,
  ${styledTheme.colors.jbtBlue} 42px,
  ${styledTheme.colors.jbtBlue} 45px,
  white 45px,
  white 48px,
  ${styledTheme.colors.jbtBlue} 48px,
  ${styledTheme.colors.jbtBlue} 51px,
  white 51px,
  white 54px,
  ${styledTheme.colors.jbtBlue} 54px,
  ${styledTheme.colors.jbtBlue} 57px,
  white 57px,
  white 60px,
  ${styledTheme.colors.jbtBlue} 60px,
  ${styledTheme.colors.jbtBlue} 63px,
  white 63px,
  white 66px,
  ${styledTheme.colors.jbtBlue} 66px,
  ${styledTheme.colors.jbtBlue} 69px,
  white 69px,
  white 72px,
  ${styledTheme.colors.jbtBlue} 72px,
  ${styledTheme.colors.jbtBlue} 75px,
  white 75px,
  white 78px,
  ${styledTheme.colors.jbtBlue} 78px,
  ${styledTheme.colors.jbtBlue} 81px,
  white 81px,
  white 84px,
  ${styledTheme.colors.jbtBlue} 84px,
  ${styledTheme.colors.jbtBlue} 87px,
  white 87px,
  white 90px,
  ${styledTheme.colors.jbtBlue} 90px,
  ${styledTheme.colors.jbtBlue} 93px,
  white 93px,
  white 96px,
  ${styledTheme.colors.jbtBlue} 96px,
  ${styledTheme.colors.jbtBlue} 99px,
  white 99px,
  white 102px,
  ${styledTheme.colors.jbtBlue} 102px,
  ${styledTheme.colors.jbtBlue} 105px,
  white 105px,
  white 108px,
  ${styledTheme.colors.jbtBlue} 108px,
  ${styledTheme.colors.jbtBlue} 111px,
  white 111px,
  white 114px,
  ${styledTheme.colors.jbtBlue} 114px,
  ${styledTheme.colors.jbtBlue} 117px,
  white 117px,
  white 120px,
  ${styledTheme.colors.jbtBlue} 120px,
  ${styledTheme.colors.jbtBlue} 123px,
  white 123px,
  white 126px,
  ${styledTheme.colors.jbtBlue} 126px,
  ${styledTheme.colors.jbtBlue} 129px,
  white 129px,
  white 132px,
  ${styledTheme.colors.jbtBlue} 132px,
  ${styledTheme.colors.jbtBlue} 135px,
  white 135px,
  white 138px,
  ${styledTheme.colors.jbtBlue} 138px,
  ${styledTheme.colors.jbtBlue} 141px,
  white 141px,
  white 144px,
  ${styledTheme.colors.jbtBlue} 144px,
  ${styledTheme.colors.jbtBlue} 147px,
  white 147px,
  white 150px,
  ${styledTheme.colors.jbtBlue} 150px,
  ${styledTheme.colors.jbtBlue} 153px,
  white 153px,
  white 156px,
  ${styledTheme.colors.jbtBlue} 156px,
  ${styledTheme.colors.jbtBlue} 159px,
  white 159px,
  white 162px,
  ${styledTheme.colors.jbtBlue} 162px,
  ${styledTheme.colors.jbtBlue} 165px,
  white 165px,
  white 168px,
  ${styledTheme.colors.jbtBlue} 168px,
  ${styledTheme.colors.jbtBlue} 171px,
  white 171px,
  white 174px,
  ${styledTheme.colors.jbtBlue} 174px,
  ${styledTheme.colors.jbtBlue} 177px,
  white 177px,
  white 180px,
  ${styledTheme.colors.jbtBlue} 180px,
  ${styledTheme.colors.jbtBlue} 183px,
  white 183px,
  white 186px,
  ${styledTheme.colors.jbtBlue} 186px,
  ${styledTheme.colors.jbtBlue} 189px,
  white 189px,
  white 192px,
  ${styledTheme.colors.jbtBlue} 192px,
  ${styledTheme.colors.jbtBlue} 195px,
  white 195px,
  white 198px,
  ${styledTheme.colors.jbtBlue} 198px,
  ${styledTheme.colors.jbtBlue} 201px,
  white 201px,
  white 204px,
  ${styledTheme.colors.jbtBlue} 204px,
  ${styledTheme.colors.jbtBlue} 207px,
  white 207px,
  white 210px,
  ${styledTheme.colors.jbtBlue} 210px,
  ${styledTheme.colors.jbtBlue} 213px,
  white 213px,
  white 216px,
  ${styledTheme.colors.jbtBlue} 216px,
  ${styledTheme.colors.jbtBlue} 219px,
  white 219px,
  white 222px,
  ${styledTheme.colors.jbtBlue} 222px,
  ${styledTheme.colors.jbtBlue} 225px,
  white 225px,
  white 228px,
  ${styledTheme.colors.jbtBlue} 228px,
  ${styledTheme.colors.jbtBlue} 231px,
  white 231px,
  white 234px,
  ${styledTheme.colors.jbtBlue} 234px,
  ${styledTheme.colors.jbtBlue} 237px,
  white 237px,
  white 240px,
  ${styledTheme.colors.jbtBlue} 240px,
  ${styledTheme.colors.jbtBlue} 243px,
  white 243px,
  white 246px,
  ${styledTheme.colors.jbtBlue} 246px,
  ${styledTheme.colors.jbtBlue} 249px,
  white 249px,
  white 252px,
  ${styledTheme.colors.jbtBlue} 252px,
  ${styledTheme.colors.jbtBlue} 255px,
  white 255px,
  white 258px,
  ${styledTheme.colors.jbtBlue} 258px,
  ${styledTheme.colors.jbtBlue} 261px,
  white 261px,
  white 264px,
  ${styledTheme.colors.jbtBlue} 264px,
  ${styledTheme.colors.jbtBlue} 267px,
  white 267px,
  white 270px,
  ${styledTheme.colors.jbtBlue} 270px,
  ${styledTheme.colors.jbtBlue} 273px,
  white 273px,
  white 276px,
  ${styledTheme.colors.jbtBlue} 276px,
  ${styledTheme.colors.jbtBlue} 279px,
  white 279px,
  white 282px,
  ${styledTheme.colors.jbtBlue} 282px,
  ${styledTheme.colors.jbtBlue} 285px,
  white 285px,
  white 288px,
  ${styledTheme.colors.jbtBlue} 288px,
  ${styledTheme.colors.jbtBlue} 291px,
  white 291px,
  white 294px,
  ${styledTheme.colors.jbtBlue} 294px,
  ${styledTheme.colors.jbtBlue} 297px,
  white 297px,
  white 300px,
  ${styledTheme.colors.jbtBlue} 300px,
  ${styledTheme.colors.jbtBlue} 303px,
  white 303px,
  white 306px,
  ${styledTheme.colors.jbtBlue} 306px,
  ${styledTheme.colors.jbtBlue} 309px,
  white 309px,
  white 312px,
  ${styledTheme.colors.jbtBlue} 312px,
  ${styledTheme.colors.jbtBlue} 315px,
  white 315px,
  white 318px,
  ${styledTheme.colors.jbtBlue} 318px,
  ${styledTheme.colors.jbtBlue} 321px,
  white 321px,
  white 324px,
  ${styledTheme.colors.jbtBlue} 324px,
  ${styledTheme.colors.jbtBlue} 327px,
  white 327px,
  white 330px,
  ${styledTheme.colors.jbtBlue} 330px,
  ${styledTheme.colors.jbtBlue} 333px,
  white 333px,
  white 336px,
  ${styledTheme.colors.jbtBlue} 336px,
  ${styledTheme.colors.jbtBlue} 339px,
  white 339px,
  white 342px,
  ${styledTheme.colors.jbtBlue} 342px,
  ${styledTheme.colors.jbtBlue} 345px,
  white 345px,
  white 348px,
  ${styledTheme.colors.jbtBlue} 348px,
  ${styledTheme.colors.jbtBlue} 351px,
  white 351px,
  white 354px,
  ${styledTheme.colors.jbtBlue} 354px,
  ${styledTheme.colors.jbtBlue} 357px,
  white 357px,
  white 360px,
  ${styledTheme.colors.jbtBlue} 360px,
  ${styledTheme.colors.jbtBlue} 363px,
  white 363px,
  white 366px,
  ${styledTheme.colors.jbtBlue} 366px,
  ${styledTheme.colors.jbtBlue} 369px,
  white 369px,
  white 372px,
  ${styledTheme.colors.jbtBlue} 372px,
  ${styledTheme.colors.jbtBlue} 375px,
  white 375px,
  white 378px,
  ${styledTheme.colors.jbtBlue} 378px,
  ${styledTheme.colors.jbtBlue} 381px,
  white 381px,
  white 384px,
  ${styledTheme.colors.jbtBlue} 384px,
  ${styledTheme.colors.jbtBlue} 387px,
  white 387px,
  white 390px,
  ${styledTheme.colors.jbtBlue} 390px,
  ${styledTheme.colors.jbtBlue} 393px,
  white 393px,
  white 396px,
  ${styledTheme.colors.jbtBlue} 396px,
  ${styledTheme.colors.jbtBlue} 399px,
  white 399px,
  white 400px
)`